import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    createAsset(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/assets', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateAsset(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/assets/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAssets(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/assets', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidAsset(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/assets/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}